<template>
  <!-- menu for customer -->
  <div class="font-sans antialiased" id="app">
    <NavbarAll />

    <section id="hero">
      <!-- Flex Container -->
      <!-- <div
        class="container flex flex-col-reverse items-center px-6 mx-auto mt-10 space-y-0 md:space-y-0 md:flex-row"
      > -->
      <!-- Left item -->
      <!-- <div class="flex flex-col mb-32 space-y-12 md:w-1/2">
          <h1
            class="max-w-md text-4xl font-bold text-center md:text-5xl md:text-left"
          >
            Track parcels effortlessly
          </h1>
          <p class="max-w-sm text-center text-darkGrayishBlue md:text-left">
            We ship and deliver parcels to your doorstep, track location of your parcels at every step of the way.
          </p>
          <div class="flex justify-center md:justify-start">
            <a
              href="#"
              class="p-3 px-6 pt-2 text-white bg-brightRed rounded-full baseline hover:bg-brightRedLight"
              >Get Started</a
            >
          </div>
        </div> -->
      <!-- Image -->
      <!-- <div class="md:w-1/2">
          <img src="@/assets/illustration-intro.svg" alt="" />
        </div> -->
      <!-- </div> -->

      <div class="grid grid-cols-12">
        <!-- blank right image -->
        <div class="col-span-1"></div>
        <div class="col-span-10">
          <div class="relative slide shadow-lg">
            <div
              class="carousel-indicators absolute bottom-0 flex h-24 w-full justify-center items-center"
            >
              <ol class="z-50 flex w-4/12 justify-center">
                <li
                  v-for="(img, i) in images"
                  :key="i"
                  class="md:w-4 md:h-4 bg-gray-300 rounded-full cursor-pointer mx-2"
                ></li>
              </ol>
            </div>
            <div class="carousel-inner relative overflow-hidden w-full">
              <div
                v-for="(img, i) in images"
                :id="`slide-${i}`"
                :key="i"
                :class="`${active === i ? 'active' : 'left-full'}`"
                class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out"
              >
                <div class="flex justify-center">
                  <img
                    class="object-center block w-full h-[50vh]"
                    :src="img"
                    alt="First slide"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- blank right image -->
        <div class="col-span-1"></div>
      </div>
    </section>
    <section>
      <div class="grid grid-cols-12">
        <div class="col-span-1"></div>
        <div class="col-span-10">
          <div class="flex flex-wrap py-4">
            <div class="w-full lg:w-6/12 xl:w-3/12 pr-4 pl-0">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg"
              >
                <div class="flex-auto p-4">
                  <div class="flex flex-wrap">
                    <div
                      class="relative w-full pr-4 max-w-full flex-grow flex-1"
                    >
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">
                        Traffic
                      </h5>
                      <span class="font-semibold text-xl text-blueGray-700">
                        350,897
                      </span>
                    </div>
                    <div class="relative w-auto pl-4 flex-initial">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-red-500"
                      >
                        <i class="far fa-chart-bar"></i>
                      </div>
                    </div>
                  </div>
                  <p class="text-sm text-blueGray-400 mt-4">
                    <span class="text-emerald-500 mr-2">
                      <i class="fas fa-arrow-up"></i> 3.48%
                    </span>
                    <span class="whitespace-nowrap"> Since last month </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg"
              >
                <div class="flex-auto p-4">
                  <div class="flex flex-wrap">
                    <div
                      class="relative w-full pr-4 max-w-full flex-grow flex-1"
                    >
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">
                        New users
                      </h5>
                      <span class="font-semibold text-xl text-blueGray-700">
                        2,356
                      </span>
                    </div>
                    <div class="relative w-auto pl-4 flex-initial">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-orange-500"
                      >
                        <i class="fas fa-chart-pie"></i>
                      </div>
                    </div>
                  </div>
                  <p class="text-sm text-blueGray-400 mt-4">
                    <span class="text-red-500 mr-2">
                      <i class="fas fa-arrow-down"></i> 3.48%
                    </span>
                    <span class="whitespace-nowrap"> Since last week </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg"
              >
                <div class="flex-auto p-4">
                  <div class="flex flex-wrap">
                    <div
                      class="relative w-full pr-4 max-w-full flex-grow flex-1"
                    >
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">
                        Sales
                      </h5>
                      <span class="font-semibold text-xl text-blueGray-700">
                        924
                      </span>
                    </div>
                    <div class="relative w-auto pl-4 flex-initial">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-pink-500"
                      >
                        <i class="fas fa-users"></i>
                      </div>
                    </div>
                  </div>
                  <p class="text-sm text-blueGray-400 mt-4">
                    <span class="text-orange-500 mr-2">
                      <i class="fas fa-arrow-down"></i> 1.10%
                    </span>
                    <span class="whitespace-nowrap"> Since yesterday </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-6/12 xl:w-3/12 pr-0 pl-4">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg"
              >
                <div class="flex-auto p-4">
                  <div class="flex flex-wrap">
                    <div
                      class="relative w-full pr-4 max-w-full flex-grow flex-1"
                    >
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">
                        Performance
                      </h5>
                      <span class="font-semibold text-xl text-blueGray-700">
                        49,65%
                      </span>
                    </div>
                    <div class="relative w-auto pl-4 flex-initial">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-blue-300"
                      >
                        <i class="fas fa-list"></i>
                      </div>
                    </div>
                  </div>
                  <p class="text-sm text-blueGray-400 mt-4">
                    <span class="text-emerald-500 mr-2">
                      <i class="fas fa-arrow-up"></i> 12%
                    </span>
                    <span class="whitespace-nowrap"> Since last month </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-1"></div>
      </div>
    </section>
    <!-- banner section -->

    <!-- Features Section -->
    <section id="features">
      <div class="grid grid-cols-12">
        <!-- blank left feature -->
        <div class="col-span-1" style="background-color: #f3f3f4"></div>
        <div class="col-span-10 p-5" style="background-color: #f3f3f4">
          <div
            class="container flex flex-col px-4 mx-auto mt-1 space-y-12 md:space-y-0 md:flex-row"
          >
            <!-- What's Different -->
            <div class="flex flex-col space-y-12 md:w-1/2">
              <h2 class="max-w-md text-4xl font-bold text-center md:text-left">
                Why Choose Our Service?
              </h2>
              <p class="max-w-sm text-center text-darkGrayishBlue md:text-left">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>
            </div>

            <!-- Numbered List -->
            <div class="flex flex-col space-y-2 md:w-1/2">
              <!-- List Item 1 -->
              <div
                class="flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row"
              >
                <!-- Heading -->
                <div
                  class="rounded-l-full bg-brightRedSupLight md:bg-transparent"
                >
                  <div class="flex items-center space-x-2">
                    <div
                      class="px-4 py-2 text-white rounded-full md:py-1 bg-brightRed"
                    >
                      01
                    </div>
                    <h3 class="text-base font-bold md:mb-4 md:hidden">
                      Track parcels
                    </h3>
                  </div>
                </div>

                <div>
                  <h3 class="hidden mb-4 text-lg font-bold md:block">
                    Track parcels
                  </h3>
                  <p class="text-darkGrayishBlue">
                    See how your day-to-day tasks fit into the wider vision. Go
                    from tracking progress at the milestone level all the way
                    done to the smallest of details. Never lose sight of the
                    bigger picture again.
                  </p>
                </div>
              </div>

              <!-- List Item 2 -->
              <div
                class="flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row"
              >
                <!-- Heading -->
                <div
                  class="rounded-l-full bg-brightRedSupLight md:bg-transparent"
                >
                  <div class="flex items-center space-x-2">
                    <div
                      class="px-4 py-2 text-white rounded-full md:py-1 bg-brightRed"
                    >
                      02
                    </div>
                    <h3 class="text-base font-bold md:mb-4 md:hidden">
                      Safe Delivery Guaranteed
                    </h3>
                  </div>
                </div>

                <div>
                  <h3 class="hidden mb-4 text-lg font-bold md:block">
                    History of previous deliveries
                  </h3>
                  <p class="text-darkGrayishBlue">
                    Set internal delivery estimates and track progress toward
                    company goals. Our customisable dashboard helps you build
                    out the reports you need to keep key stakeholders informed.
                  </p>
                </div>
              </div>

              <!-- List Item 3 -->
              <div
                class="flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row"
              >
                <!-- Heading -->
                <div
                  class="rounded-l-full bg-brightRedSupLight md:bg-transparent"
                >
                  <div class="flex items-center space-x-2">
                    <div
                      class="px-4 py-2 text-white rounded-full md:py-1 bg-brightRed"
                    >
                      03
                    </div>
                    <h3 class="text-base font-bold md:mb-4 md:hidden">
                      Everything you need in one place
                    </h3>
                  </div>
                </div>

                <!-- <div>
              <h3 class="hidden mb-4 text-lg font-bold md:block">
                Everything you need in one place
              </h3>
              <p class="text-darkGrayishBlue">
                Stop jumping from one service to another to communicate, store
                files, track tasks and share documents. Manage offers an
                all-in-one team productivity solution.
              </p>
            </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- blank right feature -->
        <div class="col-span-1" style="background-color: #f3f3f4"></div>
      </div>
      <!-- Flex container -->
    </section>

    <!-- Testimonials -->
    <section id="testimonials">
      <!-- Container to heading and testm blocks -->
      <div class="max-w-6xl px-5 mx-auto mt-10 text-center">
        <!-- Heading -->
        <h2 class="text-4xl font-bold text-center">Customer Testimony?</h2>
        <!-- Testimonials Container -->
        <div class="flex flex-col mt-24 md:flex-row md:space-x-6">
          <!-- Testimonial 1 -->
          <div
            class="flex flex-col items-center p-6 space-y-6 rounded-lg bg-veryLightGray md:w-1/3"
          >
            <img src="../assets/avatar-anisha.png" class="w-16 -mt-14" alt="" />
            <h5 class="text-lg font-bold">Anisha Li</h5>
            <p class="text-sm text-darkGrayishBlue">
              “Manage has supercharged our team’s workflow. The ability to
              maintain visibility on larger milestones at all times keeps
              everyone motivated.”
            </p>
          </div>

          <!-- Testimonial 2 -->
          <div
            class="hidden flex-col items-center p-6 space-y-6 rounded-lg bg-veryLightGray md:flex md:w-1/3"
          >
            <img src="../assets/avatar-ali.png" class="w-16 -mt-14" alt="" />
            <h5 class="text-lg font-bold">Ali Bravo</h5>
            <p class="text-sm text-darkGrayishBlue">
              “We have been able to cancel so many other subscriptions since
              using Manage. There is no more cross-channel confusion and
              everyone is much more focused.”
            </p>
          </div>

          <!-- Testimonial 3 -->
          <div
            class="hidden flex-col items-center p-6 space-y-6 rounded-lg bg-veryLightGray md:flex md:w-1/3"
          >
            <img src="@/assets/avatar-richard.png" class="w-16 -mt-14" alt="" />
            <h5 class="text-lg font-bold">Richard Watts</h5>
            <p class="text-sm text-darkGrayishBlue">
              “Manage has supercharged our team’s workflow. The ability to
              maintain visibility on larger milestones at all times keeps
              everyone motivated.”
            </p>
          </div>
        </div>
        <!-- Button -->
        <div class="my-2">
          <a
            href="#"
            class="p-3 px-6 pt-2 text-white bg-brightRed rounded-full baseline hover:bg-brightRedLight"
            >Get Started</a
          >
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section id="cta" class="bg-buttonAccent1">
      <!-- Flex Container -->
      <div
        class="container flex flex-col items-center justify-between px-6 py-12 mx-auto space-y-12 md:py-12 md:flex-row md:space-y-0"
      >
        <!-- Heading -->
        <h2
          class="text-5xl font-bold leading-tight text-center text-white md:text-4xl md:max-w-xl md:text-left"
        >
          Why Wait? Order Now
        </h2>
        <!-- Button -->
        <div>
          <a
            href="#"
            class="p-3 px-6 pt-2 text-brightRed bg-white rounded-full shadow-2xl baseline hover:bg-gray-900"
            >Get Started</a
          >
        </div>
      </div>
    </section>

    <!-- Footer -->
    <div class="grid grid-cols-12 pt-5" style="background-color: #f3f3f4">
      <div class=""></div>
      <div class="col-span-12">
        <div
          class="max-w-screen-xl w-full mx-auto px-6 sm:px-8 lg:px-16 grid grid-rows-6 sm:grid-rows-1 grid-flow-row sm:grid-flow-col grid-cols-3 sm:grid-cols-12 gap-4"
        >
          <div
            class="row-span-2 sm:col-span-4 col-start-1 col-end-4 sm:col-end-5 flex flex-col items-start"
          >
            <img src="@/assets/lol.png" alt="" style="width: 50%" />
            <p class="mb-4">
              <strong class="font-medium">FreshLux </strong>Parcel Delivery
              Serice. We deliver parcels from abroad.
            </p>
            <div class="flex w-full mt-2 mb-8 -mx-2">
              <div
                class="mx-2 bg-white-500 rounded-full items-center justify-center flex p-2 shadow-md"
              >
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"
                    fill="rgba(245,56,56,1)"
                  ></path>
                </svg>
              </div>
              <div
                class="mx-2 bg-white-500 rounded-full items-center justify-center flex p-2 shadow-md"
              >
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z"
                    fill="rgba(245,56,56,1)"
                  ></path>
                </svg>
              </div>
              <div
                class="mx-2 bg-white-500 rounded-full items-center justify-center flex p-2 shadow-md"
              >
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 0 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
                    fill="rgba(245,56,56,1)"
                  ></path>
                </svg>
              </div>
            </div>
            <p class="text-gray-400">©2022FreshLux</p>
          </div>
          <div
            class="row-span-2 sm:col-span-2 sm:col-start-7 sm:col-end-9 flex flex-col"
          >
            <!-- <p class="text-black-600 mb-4 font-medium text-lg">Product</p>
              <ul class="text-black-500 ">
                
              </ul> -->
          </div>
          <div
            class="row-span-2 sm:col-span-2 sm:col-start-9 sm:col-end-11 flex flex-col"
          >
            <p class="text-black-600 mb-4 font-medium text-lg">Product</p>
            <ul class="text-black-500">
              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                Pricing<!-- -->
              </li>
              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                Locations<!-- -->
              </li>

              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                Countries<!-- -->
              </li>
            </ul>
          </div>
          <div
            class="row-span-2 sm:col-span-2 sm:col-start-11 sm:col-end-13 flex flex-col"
          >
            <p class="text-black-600 mb-4 font-medium text-lg">Engage</p>
            <ul class="text-black-500">
              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                Contact Us<!-- -->
              </li>
              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                FAQ<!-- -->
              </li>

              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                About Us<!-- -->
              </li>
              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                Privacy Policy<!-- -->
              </li>
              <li
                class="my-2 hover:text-orange-500 cursor-pointer transition-all"
              >
                Terms of Service<!-- -->
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class=""></div>
    </div>
  </div>
</template>

<script>
import NavbarAll from "@/components/NavbarAll";
export default {
  components: { NavbarAll },
  data() {
    return {
      images: [require("@/assets/ship.jpeg"), require("@/assets/banner1.jpg")],
      active: 0,
    };
  },
  mounted() {
    let i = 0;
    setInterval(() => {
      if (i > this.images.length - 1) {
        i = 0;
      }
      this.active = i;
      i++;
    }, 3000);
  },
};
</script>

<style>
.left-full {
  left: -100%;
}

.carousel-item {
  float: left;
  position: relative;
  display: block;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
}

.carousel-item.active {
  left: 0;
}
</style>
